import { withRouter } from 'react-router';
import { branch, compose, lifecycle, renderComponent, renderNothing, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { getActiveShopId, getIsCommissionShop, getIsShop } from '../../auth/selectors';
import {
  postponeAutoPayoutSuggestion,
  acceptAutoPayoutSuggestion,
  fetchAutoPayoutSuggestionStatus,
} from './actions';
import SuggestAutoPayoutModal from './SuggestAutoPayoutModal';
import AutoPayoutDeclinedFeedbackModal from './AutoPayoutDeclinedFeedbackModalContainer';
import AutoPayoutConfirmedModal from './AutoPayoutConfirmedModal';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../modules/infra/feature-flags';

const MODAL_VIEWS = {
  SUGGEST_VIEW: 1,
  DECLINE_FEEDBACK_VIEW: 2,
  ACCEPT_CONFIRM_VIEW: 3,
};

export default compose(
  withRouter,
  withInjectFeatureFlagsToProps([flagNames.AUTOPAYOUT_SELF_SERVE]),
  connect((state, ownProps) => ({
    isCommissionShopUser: getIsShop(state) && getIsCommissionShop(state),
    shopId: getActiveShopId(state),
    isUserImpersonated: state.auth.isUserImpersonated,
    canGoToAutoPayoutSelfServe: ownProps[flagNames.AUTOPAYOUT_SELF_SERVE],
  })),
  withState('openedView', 'setOpenedView', null),
  withHandlers({
    onGoToSetupHandler: props => () => {
      if (!props.isUserImpersonated) {
        props.router.push('/settings/auto-payout');
        acceptAutoPayoutSuggestion(props.shopId, 'self-serve');
      }

      props.setOpenedView(null);
    },
    onLearnMoreHandler: props => () => {
      if (!props.isUserImpersonated) {
        acceptAutoPayoutSuggestion(props.shopId, 'help-requested')
          .then(() => {
            props.setOpenedView(MODAL_VIEWS.ACCEPT_CONFIRM_VIEW);
          });
      } else {
        props.setOpenedView(null);
      }
    },
    onPostponeHandler: props => () => {
      if (!props.isUserImpersonated) {
        postponeAutoPayoutSuggestion(props.shopId);
      }
      props.setOpenedView(null);
    },
    onDeclineHandler: props => () => {
      props.setOpenedView(props.isUserImpersonated ? null : MODAL_VIEWS.DECLINE_FEEDBACK_VIEW);
    },
    onCloseFollowUpModalHandler: props => () => {
      props.setOpenedView(null);
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.isCommissionShopUser) {
        fetchAutoPayoutSuggestionStatus(this.props.shopId).then((status) => {
          if (status && status.showPopup) {
            this.props.setOpenedView(MODAL_VIEWS.SUGGEST_VIEW);
          }
        });
      }
    },
  }),
  branch(
    props => props.openedView === MODAL_VIEWS.SUGGEST_VIEW,
    renderComponent(SuggestAutoPayoutModal),
  ),
  branch(
    props => props.openedView === MODAL_VIEWS.DECLINE_FEEDBACK_VIEW,
    renderComponent(AutoPayoutDeclinedFeedbackModal),
  ),
  branch(
    props => props.openedView === MODAL_VIEWS.ACCEPT_CONFIRM_VIEW,
    renderComponent(AutoPayoutConfirmedModal),
  ),
  renderNothing,
);
